import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "SearchBox" })
export default class SearchBox extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public search: string = null;
    public suggestions: any[] = [];
    public suggestionListIndex: number = -1;
    public isSuggestionNotFound: boolean = false;
    public debounceTimeOut: any = null;

    @Watch("search") onSearchChange(newText) {
        this.debounceGetSuggestions(newText, 500);
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        const outsideClickListener = event => {
            if (!this.$el.contains(event.target)) {
                this.closeSearch();
            }
        }

        document.addEventListener("click", outsideClickListener);
    }

    public debounceGetSuggestions(search: any, delay: number) {
        let self = this;

        clearTimeout(this.debounceTimeOut);
        this.debounceTimeOut = setTimeout(async function (context) {
            if (search != null && search.length >= 3) {
                await self.getSuggestions();
            } else if (search === null || search.length === 0) {
                self.closeSearch();
            }
        }, delay, this);
    }

    public async getSuggestions() {
        this.isLoading = true;

        const response = await Axios.post(this.routes.Search_GetSuggestions, { search: this.search });

        this.suggestions = response.data;
        this.suggestionListIndex = -1;

        this.isSuggestionNotFound = this.suggestions.length === 0;

        this.isLoading = false;
    }

    public setSearch() {
        if (this.search) {
            GTagHelper.sendEvent("view_search_results", "show_all");
            (<any>window).location = this.routes.Search_List + "?search=" + this.search;
        }
    }

    public moveUp() {
        if (this.suggestions.length !== 0 && this.suggestionListIndex > 0) {
            this.suggestionListIndex--;
        }
    }

    public moveDown() {
        if (this.suggestions.length !== 0 && this.suggestionListIndex < this.suggestions.length - 1) {
            this.suggestionListIndex++;
        }
    }

    public suggestionSelect(index: number) {
        if (index !== -1) {
            this.suggestionListIndex = index;
        }

        if (this.suggestions.length !== 0 && this.suggestionListIndex !== -1) {
            let selectedSuggestion = this.suggestions[this.suggestionListIndex];

            this.setAnalytics(selectedSuggestion.linkUrl);
            window.location.href = selectedSuggestion.linkUrl;

            this.closeSearch();
        } else {
            this.setSearch();
        }
    }

    public toDetail(linkUrl : string) {
        this.setAnalytics(linkUrl);
        window.location.href = linkUrl;
    }

    public setAnalytics(linkUrl: string) {
        GTagHelper.sendEvent("view_search_results", "suggestion")
    }

    public closeSearch() {
        this.suggestions = [];
        this.suggestionListIndex = -1;
        this.isSuggestionNotFound = false;
        this.search = null;
    }
};